import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {isNullOrUndefined} from "util";
import {edsEnvConfiguration} from "../../../environments/edsEnvConfiguration";
import {combineLatest} from "rxjs";


@Component({
  selector: 'edsng-redirect-to-eds',
  templateUrl: './redirect-to-eds.component.html',
  styleUrls: ['./redirect-to-eds.component.css']
})
export class RedirectToEdsComponent implements OnInit {

  private lastRedirected = null;

  constructor(private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    combineLatest([this.route.params, this.route.queryParams]).subscribe(
      ([x, y]) => {
        const params = new URLSearchParams();
        Object.keys(y).forEach((key) => params.set(key, y[key]));

        const link = x.link;
        this.router.navigate([''], {skipLocationChange: true}).then((result) => {
          if (!isNullOrUndefined(link)) {
            this.goToUrl(link + "?" + params.toString());
          }
        });
      });
  }

  private goToUrl(link: string) {
    // added self to avoid double load of page
    link.trim().toLowerCase().startsWith("http")
      ? window.open(link, '_self')
      : window.open(edsEnvConfiguration.edsUrl + link, '_self');
  }

}
